module.exports = __webpack_public_path__ + "static/dollar_icon_gradient-039e896fc4e1490665a536da090bd50d.png";